module.exports = function (bootstrap) {
    bootstrap.directive('chevron', ['$timeout', function ($timeout) {
       return {
           restrict: "A",
           scope: {
             chevron: "="
           },
           template: require("articles/chevron.html"),
           controller: ['$scope', '$state', function ($scope, $state) {
               var isValidStep = function(nextStep) {
                   var currentStep = $scope.chevron.steps[$scope.chevron.step-1];
                   if (currentStep.validSteps && currentStep.validSteps.length > 0) {
                       return $.inArray(nextStep, currentStep.validSteps) >= 0;
                   } else {
                       return true;
                   }
               };

               $scope.setActive = function() {
                   for (var i = 0; i < $scope.chevron.steps.length; i++) {
                       if ($state.current.name === $scope.chevron.steps[i].state) {
                           $scope.chevron.step = i+1;
                       }
                   }
               };

               $scope.goto = function(step) {
                   if ($scope.chevron.step > step && isValidStep(step)) {
                       $state.go($scope.chevron.steps[step-1].state, $scope.chevron.parameters);
                       $scope.chevron.step = step;
                   }
               };

               $scope.getCurrentClass = function(step) {
                   if ($scope.chevron.step === step) {
                       return  "current";
                   }
                   if ($scope.chevron.step > step) {
                       return  "completed";
                   }
               };


               $scope.setActive();
           }],
           link: function (scope, element, attributes) {
              var adjustHeight = function () {
                var buttons = element.find("button");
                var dividers = element.find("button .divider");

                var maxButtonHeight = 0;
                angular.forEach(buttons, function (item) {
                  var h = $(item).innerHeight();
                   if (h > maxButtonHeight) {
                       maxButtonHeight = h;
                   }
                });

                angular.forEach(buttons, function (item) {
                    $(item).css({"min-height": maxButtonHeight+"px"});
                });

                var newBorderSize = Math.floor(maxButtonHeight/2);
                angular.forEach(dividers, function (item) {
                  $(item).find(".left").css({
                    "border-top-width": newBorderSize+"px",
                    "border-bottom-width": newBorderSize+"px"
                  });

                  $(item).find(".top").css({
                    "border-bottom-width": newBorderSize+"px"
                  });

                  $(item).find(".bottom").css({
                    "border-top-width": newBorderSize+"px"
                  });
                });
              };

              var updateDividerColor = function () {
                var dividers = element.find("button .divider");
                $timeout(function () {
                  angular.forEach(dividers, function (item, index) {
                    if(index > 0
                      && $(item.parentElement.parentElement).hasClass('completed')){
                      console.log("YES");
                    }
                  });
                }, 0);
              };


              scope.$watch(function (){
                return element.height();
              }, function(newVal, oldVal){
                adjustHeight();
              });
           }
       }
    }]);
}